var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10.3,
  stroke: "#6D6970"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6D6970",
  fillRule: "evenodd",
  d: "M13.949 15.464a1 1 0 0 1-1.414-.014l-2.01-2.05a2 2 0 0 1 0-2.8l2.01-2.05a1 1 0 0 1 1.428 1.4L11.952 12l2.01 2.05a1 1 0 0 1-.013 1.414",
  clipRule: "evenodd"
})));
export default SvgLeftArrow;